import QuitaShow from './QuitaShow'
export {QuitaShow}
export default QuitaShow
